const envBackenUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:16984";
const envFrontendUrl = process.env.REACT_APP_FRONTEND_URL ?? window.location.host;
const envCryptoToken = process.env.REACT_APP_CRYPTO_TOKEN ?? window.location.host;
const envCryptoIv = process.env.REACT_APP_CRYPTO_IV ?? window.location.host;
const envApiUrlManufacturingRoute = process.env.REACT_APP_API_URL_MANUFACTURING_ROUTE || "http://localhost:27347";
export module EnvironmentConfig {
  export const backendUrl: string = envBackenUrl;
  export const frontendUrl: string = envFrontendUrl;
  export const cryptoToken: string = envCryptoToken;
  export const cryptoIv: string = envCryptoIv;
  export const apiUrlManufacturingRoute = envApiUrlManufacturingRoute;
}
